import {ClientScoutCustomerListState} from "../store/client_scout_customers_state";
import {Reducer} from "redux";
import {
    ClientScoutCustomerListAction,
    ClientScoutCustomerListActionType,
    ICallbackSearchCustomerListAction,
} from "../action/client_scout_customers_action";

const initialState: ClientScoutCustomerListState = {
    customers: [],
    customerCount: 0,
    jobCareersWithCustomerID: [],
    clientBookmarks: [],
    isLoading: false,
};

const clientScoutCustomerListReducer: Reducer<ClientScoutCustomerListState> = (state = initialState, action: ClientScoutCustomerListAction): ClientScoutCustomerListState => {
    switch (action.type) {

        case ClientScoutCustomerListActionType.REQUEST_SEARCH_CUSTOMER_LIST: {
            return Object.assign({}, state, {
                customers: state.customers,
                customerCount: state.customerCount,
                jobCareersWithCustomerID: state.jobCareersWithCustomerID,
                isLoading: true,
            });
        }
        case ClientScoutCustomerListActionType.CALLBACK_SEARCH_CUSTOMER_LIST: {
            const _action = action as ICallbackSearchCustomerListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    customers: _action.item ? _action.item.customers : [],
                    customerCount: _action.item ? _action.item.customerCount : 0,
                    jobCareersWithCustomerID: _action.item ? _action.item.jobCareersWithCustomerID : [],
                    clientBookmarks: _action.item ? _action.item.clientBookmarks : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    customers: state.customers,
                    customerCount: state.customerCount,
                    jobCareersWithCustomerID: state.jobCareersWithCustomerID,
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientScoutCustomerListReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_scout_customers_reducer.ts